import { gql } from "@apollo/client";

export const GET_PLANS_QUERY = gql`
query GetPlans {
    plans {
        id
        name
        description
        amount
        currency
        interval
        interval_count
        features
        limits
        active
        is_default
        prorata_amount
        stripe_product_id
        stripe_price_id
    }
}
`;

// Company Plans Query

export const GET_COMPANY_PLANS_QUERY = gql`
query GetCompanyPlans($company_id: ID) {
    companyPlans(company_id: $company_id) {
        id
        company_id
        plan_id
        stripe_customer_id
        stripe_subscription_id
        stripe_transaction_id
        stripe_transaction_status
        status
        start_date
        next_due_date
        ends_on
        created_at
        updated_at
        plan {
            id
            name
            description
            amount
            currency
            interval
            interval_count
            features
            limits
            active
        }
    }
}
`;

// All AI Addons Query

export const GET_ALL_AI_ADDONS_QUERY = gql`
query GetAllAIAddons {
    aiAddons {
        id
        name
        description
        pricingType
        amount
        currency
        interval
        intervalCount
        creditPoolSize
        credits
        stripeProductId
        stripePriceId
        eligiblePlanIds
        active
        type
        createdAt
        updatedAt
    }
}
`;

// My AI Addons Query (Company AI Addons)

export const GET_MY_AI_ADDONS_QUERY = gql`
query GetMyAIAddons($companyId: ID) {
    companyAIAddons(companyId: $companyId) {
        id
        companyId
        aiAddonId
        stripeSubscriptionId
        stripeCustomerId
        creditsRemaining
        creditsUsed
        status
        startDate
        nextBillingDate
        endsOn
        createdAt
        updatedAt
        aiAddon {
            id
            name
            description
            pricingType
            amount
            currency
            interval
            intervalCount
            creditPoolSize
            credits
            eligiblePlanIds
            active
            type
        }
    }
}
`;

export const GET_USAGE_CONSUMPTION_METRICS_QUERY = gql`
query UsageConsumptionMetrics {
    usageConsumptionMetrics {
        assets {
            total
            addedThisMonth
            monitored
            unmonitored
            monitoredAddedThisMonth
            unmonitoredAddedThisMonth
        }
        users {
            total
            active
            addedThisMonth
        }
        locations {
            buildings
            addedThisMonth
        }
        documents {
            total
            addedThisMonth
            totalStorageBytes
        }
        tokens {
            total
            addedThisMonth
            docTokens
            onboardingTokens
            incidentTokens
        }
        trend {
            month
            documents
            assets
            storage
            tokens
            docTokens
            onboardingTokens
            incidentTokens
        }
    }
}
`;

// Single Company Plan Query (by ID)

export const GET_COMPANY_PLAN_QUERY = gql`
query CompanyPlan($id: ID!) {
    companyPlan(id: $id) {
        id
        company_id
        plan_id
        stripe_customer_id
        stripe_subscription_id
        stripe_transaction_id
        stripe_transaction_status
        status
        start_date
        next_due_date
        ends_on
        created_at
        updated_at
        plan {
            id
            name
            description
            amount
            currency
            interval
            interval_count
            features
            limits
            active
        }
    }
}
`;
